export default __webpack_public_path__ + "e87b8556ca401bfb33f91b87bac380d3.svg";